import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import 'moment/locale/es';
import moment from 'moment';
import LanguageSelector from './language-selector';
import { getCurrentLanguageCode, changeLanguage } from './utils';
import { i18n } from '../i18n';
import { useSession } from '../../session/use-session';
import { CONTAINER_APP } from '../../../../app/containerApp/service';
import { languageOverrideQueryParam } from './constants';
import { LANGUAGES } from '../config';
export var LanguageProvider = function (_a) {
    var children = _a.children;
    var _b = useState(getCurrentLanguageCode()), currentLanguageCode = _b[0], setCurrentLanguageCode = _b[1];
    var _c = useSession(), session = _c.data, isSessionLoading = _c.isLoading;
    var isLanguageOverridenForContainerApp = useRef(false);
    useEffect(function () {
        var handleLanguageChanged = function () {
            setCurrentLanguageCode(getCurrentLanguageCode());
        };
        i18n.on('languageChanged', handleLanguageChanged);
        return function () {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);
    useEffect(function () {
        if (typeof window === 'undefined') {
            return;
        }
        var currentLanguage = getCurrentLanguageCode();
        var queryParams = new URLSearchParams(window.location.search);
        var languageOverride = queryParams.get(languageOverrideQueryParam);
        var isLanguageOverriden = !!queryParams.get(CONTAINER_APP) && !!languageOverride;
        var isLanguageValid = !!languageOverride && LANGUAGES.includes(languageOverride);
        if (isLanguageOverriden && isLanguageValid && !isLanguageOverridenForContainerApp.current) {
            isLanguageOverridenForContainerApp.current = true;
            moment.locale(languageOverride);
            setCurrentLanguageCode(languageOverride);
            if (languageOverride !== currentLanguage) {
                changeLanguage(languageOverride);
            }
        }
    }, []);
    useEffect(function () {
        var _a;
        if (!isSessionLoading && !isLanguageOverridenForContainerApp.current) {
            var preferredLanguage = ((_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.preferredLanguage) || 'en';
            var currentLanguage = getCurrentLanguageCode();
            moment.locale(preferredLanguage);
            if (preferredLanguage !== currentLanguage) {
                changeLanguage(preferredLanguage);
            }
        }
    }, [session, isSessionLoading]);
    return (_jsxs("div", { children: [children, _jsx(LanguageSelector, {})] }, currentLanguageCode));
};
